
export const BASE_URL = 'https://cnapi.ipcs.vip/api'
export const IMG_URL = 'https://cnapi.ipcs.vip'


export const windowFontList = {
  'Windows7': [
    'Arial',
    'Calibri',
    'Cambria Math',
    'Cambria',
    'Candara',
    'Comic Sans MS',
    'Consolas',
    'Constantia',
    'Corbel',
    'Courier New',
    'Ebrima',
    'Franklin Gothic',
    'Gabriola',
    'Georgia',
    'Impact',
    'Lucida Console',
    'Lucida Sans Unicode',
    'MS Gothic',
    'MS PGothic',
    'MV Boli',
    'Malgun Gothic',
    'Marlett',
    'Microsoft Himalaya',
    'Microsoft JhengHei',
    'Microsoft New Tai Lue',
    'Microsoft PhagsPa',
    'Microsoft Sans Serif',
    'Microsoft YaHei',
    'Microsoft Yi Baiti',
    'MingLiU-ExtB',
    'Mongolian Baiti',
    'PMingLiU-ExtB',
    'Palatino Linotype',
    'Segoe Print',
    'Segoe Script',
    'Segoe UI Symbol',
    'Segoe UI',
    'SimSun',
    'SimSun-ExtB',
    'Sylfaen',
    'Trebuchet MS',
    'Verdana',
    'Webdings',
    'MS UI Gothic',
    'Microsoft Tai Le',
    'MingLiU_HKSCS-ExtB',
    'Symbol',
  ],
  'Windows81': [
    'Arial',
    'Calibri',
    'Cambria Math',
    'Cambria',
    'Candara',
    'Comic Sans MS',
    'Consolas',
    'Constantia',
    'Corbel',
    'Courier New',
    'Ebrima',
    'Franklin Gothic',
    'Gabriola',
    'Georgia',
    'Impact',
    'Lucida Console',
    'Lucida Sans Unicode',
    'MS Gothic',
    'MS PGothic',
    'MV Boli',
    'Malgun Gothic',
    'Marlett',
    'Microsoft Himalaya',
    'Microsoft JhengHei',
    'Microsoft New Tai Lue',
    'Microsoft PhagsPa',
    'Microsoft Sans Serif',
    'Microsoft YaHei',
    'Microsoft Yi Baiti',
    'MingLiU-ExtB',
    'Mongolian Baiti',
    'PMingLiU-ExtB',
    'Palatino Linotype',
    'Segoe Print',
    'Segoe Script',
    'Segoe UI Symbol',
    'Segoe UI',
    'SimSun',
    'SimSun-ExtB',
    'Sylfaen',
    'Trebuchet MS',
    'Verdana',
    'Webdings',
    'Gadugi',
    'Javanese Text',
    'Microsoft JhengHei UI',
    'Myanmar Text',
    'Sitka Small',
    'Yu Gothic',
    'MS UI Gothic',
    'Microsoft Tai Le',
    'MingLiU_HKSCS-ExtB',
    'Symbol',
    'Segoe UI Emoji',
  ],
  'Windows8': [
    'Arial',
    'Calibri',
    'Cambria Math',
    'Cambria',
    'Candara',
    'Comic Sans MS',
    'Consolas',
    'Constantia',
    'Corbel',
    'Courier New',
    'Ebrima',
    'Franklin Gothic',
    'Gabriola',
    'Georgia',
    'Impact',
    'Lucida Console',
    'Lucida Sans Unicode',
    'MS Gothic',
    'MS PGothic',
    'MV Boli',
    'Malgun Gothic',
    'Marlett',
    'Microsoft Himalaya',
    'Microsoft JhengHei',
    'Microsoft New Tai Lue',
    'Microsoft PhagsPa',
    'Microsoft Sans Serif',
    'Microsoft YaHei',
    'Microsoft Yi Baiti',
    'MingLiU-ExtB',
    'Mongolian Baiti',
    'PMingLiU-ExtB',
    'Palatino Linotype',
    'Segoe Print',
    'Segoe Script',
    'Segoe UI Symbol',
    'Segoe UI',
    'SimSun',
    'SimSun-ExtB',
    'Sylfaen',
    'Trebuchet MS',
    'Verdana',
    'Webdings',
    'Gadugi',
    'Microsoft JhengHei UI',
    'Myanmar Text',
    'MS UI Gothic',
    'Microsoft Tai Le',
    'MingLiU_HKSCS-ExtB',
    'Symbol',
  ],
  'Windows10': [
    'Arial',
    'Calibri',
    'Cambria Math',
    'Cambria',
    'Candara',
    'Comic Sans MS',
    'Consolas',
    'Constantia',
    'Corbel',
    'Courier New',
    'Ebrima',
    'Franklin Gothic',
    'Gabriola',
    'Georgia',
    'Impact',
    'Lucida Console',
    'Lucida Sans Unicode',
    'MS Gothic',
    'MS PGothic',
    'MV Boli',
    'Malgun Gothic',
    'Marlett',
    'Microsoft Himalaya',
    'Microsoft JhengHei',
    'Microsoft New Tai Lue',
    'Microsoft PhagsPa',
    'Microsoft Sans Serif',
    'Microsoft YaHei',
    'Microsoft Yi Baiti',
    'MingLiU-ExtB',
    'Mongolian Baiti',
    'PMingLiU-ExtB',
    'Palatino Linotype',
    'Segoe Print',
    'Segoe Script',
    'Segoe UI Symbol',
    'Segoe UI',
    'SimSun',
    'SimSun-ExtB',
    'Sylfaen',
    'Trebuchet MS',
    'Verdana',
    'Webdings',
    'Gadugi',
    'Javanese Text',
    'Microsoft JhengHei UI',
    'Myanmar Text',
    'Sitka Small',
    'Yu Gothic',
    'MS UI Gothic',
    'Microsoft Tai Le',
    'MingLiU_HKSCS-ExtB',
    'Symbol',
    'Segoe UI Emoji',
    'Bahnschrift',
  ],
  'Windows11': [
    'Arial',
    'Calibri',
    'Cambria Math',
    'Cambria',
    'Candara',
    'Comic Sans MS',
    'Consolas',
    'Constantia',
    'Corbel',
    'Courier New',
    'Ebrima',
    'Franklin Gothic',
    'Gabriola',
    'Georgia',
    'Impact',
    'Lucida Console',
    'Lucida Sans Unicode',
    'MS Gothic',
    'MS PGothic',
    'MV Boli',
    'Malgun Gothic',
    'Marlett',
    'Microsoft Himalaya',
    'Microsoft JhengHei',
    'Microsoft New Tai Lue',
    'Microsoft PhagsPa',
    'Microsoft Sans Serif',
    'Microsoft YaHei',
    'Microsoft Yi Baiti',
    'MingLiU-ExtB',
    'Mongolian Baiti',
    'PMingLiU-ExtB',
    'Palatino Linotype',
    'Segoe Print',
    'Segoe Script',
    'Segoe UI Symbol',
    'Segoe UI',
    'SimSun',
    'SimSun-ExtB',
    'Sylfaen',
    'Trebuchet MS',
    'Verdana',
    'Webdings',
    'Gadugi',
    'Javanese Text',
    'Microsoft JhengHei UI',
    'Myanmar Text',
    'Sitka Small',
    'Yu Gothic',
    'MS UI Gothic',
    'Microsoft Tai Le',
    'MingLiU_HKSCS-ExtB',
    'Symbol',
    'Segoe UI Emoji',
    'Bahnschrift',
  ]
}



// WEBPACK FOOTER //
// ./src/config/config.js